(() => {
  const renderAccountMount = (mount) => {
    const templateId = mount.dataset.ccHeaderAccountMount;
    const template = templateId ? document.getElementById(templateId) : null;

    if (!template || mount.hasChildNodes()) {
      return;
    }

    mount.appendChild(template.content.cloneNode(true));
  };

  const renderAccountMounts = () => {
    document.querySelectorAll("[data-cc-header-account-mount]").forEach(renderAccountMount);
  };

  const initialiseHeaderAccount = () => {
    const hasAccountMount = document.querySelector("[data-cc-header-account-mount]");

    if (!hasAccountMount) {
      return;
    }

    if (!window.customElements) {
      renderAccountMounts();
      return;
    }

    Promise.all([
      customElements.whenDefined("shopify-store"),
      customElements.whenDefined("shopify-account")
    ]).then(renderAccountMounts).catch(renderAccountMounts);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialiseHeaderAccount, { once: true });
  } else {
    initialiseHeaderAccount();
  }
})();
